import { render, staticRenderFns } from "./BaseLoginPhone.vue?vue&type=template&id=65a6f780&scoped=true"
import script from "./BaseLoginPhone.vue?vue&type=script&lang=js"
export * from "./BaseLoginPhone.vue?vue&type=script&lang=js"
import style0 from "./BaseLoginPhone.vue?vue&type=style&index=0&id=65a6f780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6f780",
  null
  
)

export default component.exports